import { safeParse } from './index';

/**
 * Decrypts a JWT string
 *
 * @example
 * import parseJwt from '@carvana/futilities/parseJwt';
 * parseJwt("eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsIng1dCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyIsImtpZCI6IklUSFFuQjdMa3Q5TVBhRGo0ajI5VFdRNDJDbyJ9.eyJpc3MiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkiLCJhdWQiOiJodHRwczovL2NhcnZhbmEtYXV0aC1kZXYuYXp1cmV3ZWJzaXRlcy5uZXQvaWRlbnRpdHkvcmVzb3VyY2VzIiwiZXhwIjoxNTYzNDAxMDk4LCJuYmYiOjE1NjM0MDA3OTgsImNsaWVudF9pZCI6IkNhcnZhbmFDb21EZWxlZ2F0aW9uIiwic2NvcGUiOiJjYXJ2YW5hX2NvbSIsInN1YiI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImF1dGhfdGltZSI6MTU2MzQwMDc5OCwiaWRwIjoiaWRzcnYiLCJyb2xlIjpbImFkbWluIiwiY3VzdG9tZXJzZXJ2aWNlIiwiZGV2ZWxvcGVyIiwiRW5naW5lZXJpbmciLCJpbXBlcnNvbmF0ZSIsIkltcGVyc29uYXRlVXNlciIsIlByZS1GaSIsIlFDVGVjaCIsIlFDVGVjaExlYWQiLCJ1c2VyIl0sIm5hbWUiOiJ0eWxlci5jaGVzd2lja0BjYXJ2YW5hLmNvbSIsImlzX2ltcGVyc29uYXRpbmciOiJGYWxzZSIsImltcGVyc29uYXRpbmdfdXNlciI6IjllYzE5NDQzLTI0NmEtNDE4ZS1hYWEzLTJlMTU0MjA2NjU2NyIsImFtciI6WyJ0cnVzdGVkIl19.A6KJ1lhhgSvdomZ81-QUBJTpzF2JAkBgg49eoYjPj49Pa3dUWbUruQBz8TMNLOHTJCzyfEbK8AUF91bOOuNrGZqZXosbmiRRLF_iootilMLnAQ_28Na9UPDgy0-sOz0ujAGV3XU4LkYiaM2Q4fH1QJ55qX6QuAUJklErt2576c3zrwt91QdP3xw-gWyUx4Bo30ba0iVByZQgeaf4bnrXVMWN9smdQV0jMNAJ1tGW85TEWA_aU7E--nC5E0e57n3iK-jPwqInJLCWcR4KgeNjWuyp3gWONMGjd1E6eK2EYrInY976d1Sp18lS7gl_JAj0bdkD0r5MqfWkE34EYfhyhQ")
 * () => {
 * amr: ["trusted"]
 * aud: "https://carvana-auth-dev.azurewebsites.net/identity/resources"
 * auth_time: 1563400798
 * client_id: "CarvanaComDelegation"
 * exp: 1563401098
 * idp: "idsrv"
 * impersonating_user: "9ec19443-246a-418e-aaa3-2e1542066567"
 * is_impersonating: "False"
 * iss: "https://carvana-auth-dev.azurewebsites.net/identity"
 * name: "tyler.cheswick@carvana.com"
 * nbf: 1563400798
 * role: (10) ["admin", "customerservice", "developer", "Engineering", "impersonate", "ImpersonateUser", "Pre-Fi", "QCTech", "QCTechLead", "user"]
 * scope: "carvana_com"
 * sub: "9ec19443-246a-418e-aaa3-2e1542066567"
 * }
 *
 * Reformatted from https://stackoverflow.com/a/38552302
 */

const parseJwt = (token: string) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
        .join('')
    );
    return safeParse(jsonPayload);
  } catch (err) {
    return {};
  }
};

export default parseJwt;
